export const breackpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

export const colors = {
  customBeige: "#c9b09a",
  customBgc: "#dbd0be",
  customWhite: "#f4eee3",
  customGrey: "#84735e",
  customBrown: "#885a3a",
  customLightBrown: "#a77d54",
  customActiveBgc: "#55555550",
};

export const textContent = {
  heading: "Авторські екскурсії Римом та околицями",
  main: "Рим - це живий музей під відкритим небом. Він захопить вас з першого погляду на Колізей і Пантеон; заінтригує рештками римських форумів та атмосферними двориками; вразить красою площ, церков, фонтанів, терас й зачарує смаком карбонари, піци Маргарити, джелато й тірамісу. \nА ще - це центр всесвітнього шопінгу, мистецьких подій та італійського «солодкого життя»! Рим не залишить вас байдужим, якщо знати куди йти, що дивитись та дегустувати. Саме в цьому я хочу бути вам корисною. Адже всі дороги ведуть в Рим.",
  about:
    "Привіт, я Ольга – твоя подруга в Римі та Тіволі. \nЗі студентства вивчила італійську мову заради її краси, почала відвідувати Італію з 2008 року, а в 2021 переїхала з Києва в Тіволі через пристрасного італійця. \nУ Римі закінчила курси гідів Mirabilia Urbis, у Папському Григоріанському Університеті відвідувала курси з «Архітектури» та «Мистецтва». \nУ 2024 отримала ліцензію тур лідера (супровід туристів), а у 2025 – європейську ліцензію гіда. \nБезтямно закохана у Рим та Тіволі й хочу закохати вас в ці місця. \nПлануєте поїхати в Рим? Звертайтесь, з радістю стану вашим провідником у античний, гастрономічний та шопінговий світ Вічного міста. \nНаша прогулянка - це легкий, веселий та доброзичливий формат.",

  contact: {
    whatsapp: "https://wa.me/393911431549",
    instagram: "https://www.instagram.com/olha.in.italy",
    instaShort: "@olha.in.italy",
  },
};

export const tours = [
  {
    id: "c91f92cj",
    title: "Ciao, ROMA. Оглядова екскурсія Римом ",
    description:
      "Запрошую вас у подорож крізь час — тригодинну оглядову екскурсію Римом, яка подарує незабутнє знайомство з Вічним містом. За цей час ми побачимо найвідоміші пам’ятки, прогуляємося найкрасивішими вуличками, піднімімось на тераси та відчуємо справжній пульс міста, де кожен камінь дихає історією. \nМаршрут продуманий так, щоб ви побачили найголовніше: Колізей і Римський форум, елегантну Площу Венеції, фонтан Треві, Пантеон, Площу Навона і, звичайно, Іспанські сходи. Я розповім вам про імператорів і художників, архітекторів і мандрівників, які залишили тут свій слід. І все це — у легкій, живій розповіді, з цікавинками та легендами, які оживляють кам’яну велич Риму. \nЦе не просто екскурсія — це побачення з містом, яке закохує з першого погляду. Ми пройдемо вузькими вуличками, де пахне кавою й історією, побачимо фасади, що змінювалися століттями, і затримаємось у місцях, де хочеться просто мовчки стояти й дивитися. \nІдеально для першого знайомства з Римом. Легко, красиво, емоційно. Як сама Італія.",
    image: "/images/91.webp",
    plan: [
      "Колізей (ззовні) ",
      " Арка Костянтина ",
      " Імператорські та римський форуми ",
      " Площа Венеції ",
      " Фонтан Треві ",
      " Іспанські сходи ",
      " Пантеон ",
      " Площа Навона",
    ],
    costs: [{ time: "3 год", price: "150 € " }],
  },
  {
    id: "77yo7nw5",
    title: "Римські канікули - прогулянка на день",
    description:
      "Запрошую вас на 6-годинну захопливу прогулянку Вічним містом — це ваші римські канікули, про які хочеться розповідати друзям і згадувати ще довго! \nМи пройдемо всі головні скарби Риму: від величного Колізею й Арки Константина — до площі Навона й фонтану Треві, зазирнемо до античних Форумів, побачимо Ларго-Арджентіна, Кампо-де-Фьорі, Іспанські сходи та Народну площу. І навіть зазирнемо на острів Тіберіна! \nЦе не буде нудна хронологія дат і правителів. Це буде легка, жива і весела прогулянка — з цікавинками, легендами, історіями з життя реальних людей. Ми уникатимемо натовпів, зазиратимемо в атмосферні дворики, зупинимось на перерву, щоб випити кави, скуштувати джелато або насолодитися обідом, як справжні римляни. \nЦе ідеальний формат для тих, хто хоче побачити максимум, але без поспіху й перевантаження. Красива, тепла, душевна пригода у серці Італії.",
    image: "/images/72.webp",
    plan: [
      "Колізей (ззовні)",
      "Арка Костянтина",
      "Імператорські та римський форуми ",
      "Площа Венеції ",
      "Театр Марцелла",
      "Форум Боаріо",
      "Острів Тіберіна",
      "Портик Октавії",
      "Ларго Арджентіна",
      "Кампо дей Фьорі ",
      "Площа Навона ",
      "Пантеон (ззовні) ",
      "Фонтан Треві ",
      "Іспанські сходи ",
      "Народна Площа",
    ],
    costs: [{ time: "6 год", price: "300 €" }],
  },
  {
    id: "t5vyg761",
    title: "Тіволі та його вілли - д’Есте й Адріана",
    description:
      "Містечко Тіволі старше за Рим майже на 500 років й найантичніше у всьому регіоні Лаціо. Воно зберігає історію гордих тібуртинців, які воювали з римськими імператорами та єпископами. Місто подарувало Риму три акведуки, на його теренах  - термальні джерела, травертинові шахти, унікальний сорт винограду - Піцутелло. Ми побачимо з вами рестки храмів Вести та Сібілли, датовані  I ст. до н.е., побуваємо у Середньовічному кварталі, відвідаємо римський форум та панорамний майданчик. Візит на віллу д’Есте - Всесвітня спадщина Юнеско  - це прогулянка серед розкішних садів та фонтанів епохи Відродження, 500-річних платанів та мальовничих залів палацу. За бажанням - обід в одному з найантичніших ресторанів міста з неперевершеними видами, а також візит на віллу Адріана - величезна площа з рестками палаців, терм, храмів, театрів - 2 ст. н. е.Ви можете дістатись до Тіволі самостійно, або ж замовити транфер.",
    image: "/images/pexels-gottapics-13816327.jpg",
    costs: [
      {
        time: "3 год (Тіволі та вілла д’Есте)",
        price: "150 € + трансфер та обід (за бажанням)",
      },
      {
        time: "6 год (Тіволі та вілла д’Есте, вілла Адріана)",
        price: "300 € + трансфер та обід (за бажанням)",
      },
    ],
    plan: "",
  },
  {
    id: "ecs7ospx",
    title: "Фуд-тур: Італія на смак",
    description:
      "Під час нашої гастрономічної прогулянки по Кампо дей Фьорі ми дізнаємось про знамениті страви римської кухні, продегустуємо піцу в античній пекарні, зробимо зупинку в м’ясній лавці, де спробуємо найсмачніші пармезан та прошуто, зайдемо в атмосферну енотеку, а також посмакуємо артішоками по-юдейські й по-римські в Єврейському гетто. А на десерт - пиріг з рікотою, тірамісу чи джелато.",
    image: "/images/pexels-unkdevil-19130186.webp",
    costs: [{ time: "2 год", price: "120 € + дегустації (від 35 євро/особа)" }],
    plan: "",
  },
  {
    id: "0apqw30k",
    title: "Арт-прогулянка «Рим геніїв та шедеврів»",
    description:
      "Рим був і залишається місцем, де генії всіх епох знаходили натхнення, творили й залишали спадщину, яка захоплює та надихає нас і сьогодні. Під час прогулянки ми знайомимся з шедеврами Мікеланджело, Рафаеля, Караваджо, Берніні, Бороміні, Канова та ін.геніїв. Побачимо будинки, де жили й творили митці, дізнаємось про найдраматичніші моменти їхнього життя та спробуємо відкрити таємницю їхнього натхнення. Маршрут пролягає від Колізею до Іспанських сходів через дворики, палаци, церкви, провулки Риму.",
    image: "/images/pexels-aleksandra-zmuda-9516327-13829408.webp",
    costs: [{ time: "3 год", price: "150 €" }],
    plan: "",
  },
];

export const reviews = [
  {
    profile: "@anna__ivashyna",
    review:
      "Ольго, дуже дякуємо за проведену екскурсію, море вражень, все дуже цікаво, ми потім ще пішли на обід в місце, яке ви порекомендували (Settimio All`Arancio) нам дуже сподобалось. ",
    link: "https://www.instagram.com/anna__ivashyna/",
    avatar: "anna__ivashyna",
    place: "Україна, Київ, Запоріжжя",
  },
  {
    profile: "@yulia_lok",
    review:
      "Оля, дуже дякую за сьогоднішній день!!! Сюрприз для мами в день народження був неперевершений. Ви фантастично цікаво розказали та показали все, навіть донька в захваті… а в наш час здивувати підлітків можуть лише мега професіонали своєї справи!!!!",
    link: "https://www.instagram.com/yulia_lok/",
    avatar: "yulia_lok",
    place: "Україна",
  },
  {
    profile: "@annette_osiiuk",
    review:
      "Нам все дуже сподобалось! Дякуємо вам! Прогулянка в Римі чудова та змістовна, йдеш слухаєш насолоджуєшся, а не бігаєш по гугл карті. Тіволі теж чарівне місце, ми як заміські жителі зацінили спокій та відпочили. Ресторан - це як вишенька на торті! Нам було дуже смачно. Дякуємо за рекомендації та турботу! ",
    link: "https://www.instagram.com/annette_osiiuk/",
    avatar: "annette_osiiuk",
    place: "Україна",
  },
  {
    profile: "@elite_show",
    review:
      "Наш милий український гід у Римі, Олечка, дякуємо за наше тепле знайомство з тобою, неймовірну екскурсію, надзвичайну прихільність, захополюючі розповіді, малолюдні вулиці, таємниці історій та невідомі загалу роботи світових митців. Ти зробила Рим ще ближче для нас. Дякуємо за теплоту і легкість спілкування! Grazie mille! ",
    link: "https://www.instagram.com/elite__show/",
    avatar: "elite_show",
    place: "Україна",
  },
  {
    profile: "@ruslanaorlovska",
    review:
      "Ольга проводить класні індивідуальні екскурсії по Риму. Допомогла нам спланувати наше знайомство з давнім містом. Пояснила все по організаційних моментах, по ресторанах, кафе, транспорту тощо. Дала купу корисних посилань. Дякую! Я дуже приємно вражена!",
    link: "https://www.instagram.com/ruslanaorlovska/",
    avatar: "ruslanaorlovska",
    place: "Литва, Вільнюс",
  },
  {
    profile: "@simpa.hanna",
    review:
      "Сьогодні в нас була неймовірна ознайомча екскурсія по Риму з україномовним екскурсоводом @olha.in.italy\nЩиро рекомендую! Цікаві історії, оминали натовпи туристів затишними вуличками, побачили немовірну кількість пам’яток. Перше знайомство з вічним містом вдалось! ",
    link: "https://www.instagram.com/simpa.hanna/",
    avatar: "simpa_hanna",
    place: "Україна",
  },
  {
    profile: "@mariia.mohina",
    review:
      "Дякуємо за неймовірний день, за цей нетуристичний, а справжній Рим, який цікавий не головними вуличками, а таємничими провулками, де ти знаходеш найкращу історію. Олічко, дуже тобі дякуємо за сьогоднішній день! ",
    link: "https://www.instagram.com/mariia.mohina/",
    avatar: "mariia_mohina",
    place: "Україна",
  },
  {
    profile: "Катерина",
    review:
      "Ольго, хочу вам подякувати за проведений з вами час. Це було дуже цікаво і дорослим і дитині. А це показник неабиякий. \nЯкщо б дивились Рим самі, то по-перше не розуміли б що дивимось. А по друге такі місця туристам знати нереально. Тому тим, хто сумнівається  - не сумнівайтесь! Беріть екскурсію у Ольги. Це дійсно круто!!!! Ще раз дякую! ",
    link: "",
    avatar: "pexels-unchalee-srirugsar-14114-85773",
    place: "Україна, Миколаїв ",
  },
  {
    profile: "@udgen1302",
    review:
      "Олічко, хочу сказати вам величезне дякую! Ви найкращий гід Італії! Ви закохали нас в це місто. У нас дуже багато вражень та величезних позитивних емоцій! Величезне вам дякую! ",
    link: "https://www.instagram.com/udgen1302/",
    avatar: "udgen1302",
    place: "Україна, Одеса",
  },
];
